<template>
    <div>
        <dt-modal :modalVisible="editModalVisible" :isCustomFooter="true" :modalWidth="500" class="code-modal">
            <template slot="customSlot">
                <div class="modal-content">
                    <p class="title">需要验证您的身份</p>
                    <p class="sub-title">为了您的账号安全，请进行身份验证。</p>
                    <p style="margin-bottom: 15px;">请输入从已绑定的账号中获取的6位数字验证码</p>
                    <div>
                        <template v-for="i in codeLength">
                            <Input v-model="code[i - 1]" maxlength="1" :ref="`code${i}Ref`"
                                @on-change="changeCode($event, i + 1)" :autofocus="i === 1">
                            </Input>
                        </template>
                    </div>
                </div>
            </template>
            <template slot="customFooterSlot">
                <Button type="primary" @click="messageLogin" :loading="sureBtnLoading">确认
                </Button>
                <Button @click="logout" v-if="showExitBtn">退出登录</Button>
            </template>
        </dt-modal>
    </div>
</template>

<script>
import Cookies from 'js-cookie';
import { findAppId, editUserPassWord, findSafeCode, findSMSCodeByMobile, checkMobileCodeAPI, loginByMobileCodeAPI } from "@/service/api";
import { removeToken, removeUserId } from "@/library/js/auth.js";
import md5 from "js-md5";
const dtModal = () => import("@/components/ddtModal");
export default {
    name: "edit-password",
    props:
    {
        editModalVisible: {
            type: Boolean,
            default: false
        },
        showSimpleTip: {
            type: Boolean,
            default: true
        },
        showExitBtn: {
            type: Boolean,
            default: true
        },
        showCloseBtn: {
            type: Boolean,
            default: false
        }
    },
    components: {
        dtModal,
    },
    data() {
        return {
            sureBtnLoading: false,
            codeLength: 6,
            code: [],
            guid: '',
            phone: this.$store.getters.mobile,
            // phone: '18156001483',
            encryptTxt: 'datedu6738b274c68384f3', //加密串
            validMobileCode: false,
            captcha: null,
            reSendTime: 120,
            mobileCode: ''
        };
    },
    methods: {
        /**
         * @name 获取腾讯验证码应用id
         */
        getTxAppId() {
            findAppId({})
                .then(res => {
                    if (res.code == 1) {
                        this.appId = res.data;
                        this.captcha = new TencentCaptcha(
                            this.appId.toString(),
                            res => {
                                if (res.ret === 0) {
                                    this.queryMobieQuid(res.ticket, res.randstr);
                                }
                            },
                            { needFeedBack: false }
                        );
                        this.getVerifyCode();
                    }
                })
                .catch(error => {
                    this.$message.error(error.msg);
                });
        },
        /**
        * @name 获取验证码
        */
        getVerifyCode() {
            if (this.reSendTime == 120 || this.reSendTime == 0) {
                if (this.validateMobilePhone()) {
                    if (this.captcha) {
                        // 滑块显示
                        this.captcha.show();
                    }
                }
            }
        },
        /**
         *@name 发送手机验证码
         */
        queryMobieQuid(ticket, randstr) {
            findSafeCode({})
                .then(res => {
                    //获取安全码
                    this.guid = res.data;
                    if (this.guid) {
                        this.getSMSCode(this.guid, ticket, randstr);
                    }
                })
                .catch(error => {
                    this.$message.error(error.msg);
                });
        },
        /**
         * @name 校验手机号
         */
        validateMobilePhone() {
            let mobileRight = true;
            let reg = new RegExp("^\\d+$");
            let reg2 = new RegExp("^((-\\d+)|(0+))$");
            if (this.phone == "") {
                mobileRight = false;
            } else if (
                this.phone !== "" &&
                !reg.test(this.phone) &&
                !reg2.test(this.phone)
            ) {
                mobileRight = false;
            } else if (this.phone.length != 11) {
                mobileRight = false;
            }
            return mobileRight;
        },
        /**
        * 图像验证通过后 获取短信验证码
        */
        async getSMSCode(guid, ticket, randstr) {
            if (this.validateMobilePhone()) {
                let _this = this;
                let params = {
                    guid: guid,
                    guidEncrypted: md5(guid + _this.encryptTxt).toUpperCase(),
                    mobile: this.phone,
                    isRegister: 0,
                    userType: _this.$store.getters.userType,
                    verificationCode: ticket,
                    randstr: randstr
                };
                await findSMSCodeByMobile(params).catch(function (error) {
                    _this.$toast({
                        message: error.msg
                    });
                    return false;
                });
            } else {
                console.log(`${this.phone}手机号格式不正确`)
                return false;
            }
        },
        /**
         * @name 校验验证码
         */
        async checkMobileCode() {
            let params = {
                guid: this.guid,
                mobile: this.phone,
                mobilecode: this.mobileCode
            };
            let res = await checkMobileCodeAPI(params);
            if (res.code == 1) {
                this.validMobileCode = true;
            } else {
                this.validMobileCode = false;
            }
        },
        /**
         * @name 短信登录
         */
        async messageLogin() {
            this.mukunSettime();
            if (!this.validateMobilePhone()) {
                return;
            }
            this.mobileCode = '';
            this.code.forEach((item) => {
                this.mobileCode += item;
            })
            console.log(this.mobileCode)
            if (this.mobileCode == "") {
                this.$message.error("请输入手机验证码！");
                return;
            }
            await this.checkMobileCode();
            if (!this.validMobileCode) {
                this.$message.error("手机验证码输入错误，请验证！");
                return;
            }
            this.sureBtnLoading = true;
            let params = {
                mobile: this.phone,
                safId: this.guid,
                mobileCode: this.mobileCode,
                userType: this.$store.getters.userType,
                loginType: 5
            };
            loginByMobileCodeAPI(params)
                .then(res => {
                    this.sureBtnLoading = false;
                    if (res.code == 1) {
                        this.$store.commit("user/SET_ISCODELOGIN", false);
                        Cookies.set('codeLoginState', 1)
                    }
                })
                .catch(error => {
                    this.sureBtnLoading = false;
                    this.$message.error(error.msg);
                });
        },
        /**
         * @name 重置验证码发送时间
         */
        mukunSettime() {
            if (this.reSendTime == 0) {
                this.reSendTime = 120;
            } else {
                this.reSendTime--;
                setTimeout(() => {
                    this.mukunSettime();
                }, 1000);
            }
        },
        changeCode(e, number) {
            if (e.data) {
                if (number > 6) {
                    number = 6;
                }
                if (this.$refs['code' + number + 'Ref'][0]) {
                    this.$refs['code' + number + 'Ref'][0].focus();
                }
            } else {
                let preInput = number - 2;
                if (this.$refs['code' + preInput + 'Ref'][0]) {
                    this.$refs['code' + preInput + 'Ref'][0].focus();
                }
            }
        },
        cancelEditPass() {
            //初始化表单
        },
        saveEditPass() {
            let _this = this;
            _this.$refs["editPasswordForm"].validate((valid) => {
                if (valid) {
                    if (
                        _this.editPasswordForm.rePass !== _this.editPasswordForm.newPass
                    ) {
                        _this.$Message.error("两次输入密码不一致");
                        return;
                    }
                    _this.savePassLoading = true;
                    // 修改密码 并且更新弱密码的状态
                    let params = {
                        userId: _this.$store.getters.userId,
                        oldPassWord: _this.editPasswordForm.oldPass,
                        newPassWord: _this.editPasswordForm.newPass,
                    };
                    editUserPassWord(params)
                        .then(function (result) {
                            _this.savePassLoading = false;
                            if (result && parseInt(result.code) === 1) {
                                _this.$Message.success("修改成功");
                                if (_this.showCloseBtn) {
                                    _this.cancel();
                                } else {
                                    _this.$store.commit("user/SET_WEAKPASSWORD", false);
                                }
                            } else {
                                _this.$Message.error(result.msg);
                            }
                        })
                        .catch(function (error) {
                            _this.savePassLoading = false;
                            _this.$Message.error(error.msg);
                        });
                }
            });
        },
        cancel() {
            this.cancelEditPass();
            this.$emit("close-modal");
        },

        /**
         * 退出
         */
        logout() {
            let _this = this;
            _this.$Modal.confirm({
                title: "提示",
                content: "<p>确认退出吗?</p>",
                onOk: () => {
                    //清除所有cookie
                    removeToken();
                    removeUserId();
                    _this.$store.dispatch("menu/setSelectedMenuId", "");
                    ssoClient.logout();
                },
            });
        }
    },
    mounted() {
        this.getTxAppId();
        this.$nextTick(() => {
            if (this.$refs.code1Ref)
                this.$refs.code1Ref.focus();
        })

    }
};
</script>

<style lang="scss" scoped>
.tipsText {
    text-align: center;
    margin-top: 10px;
    margin-bottom: 25px;
    font: bold 15px "幼圆";
}


.modal-content {
    font-size: 16px;
    color: #000;
}

.title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 30px;
}

.sub-title {
    margin-bottom: 20px;
}

.ivu-input-wrapper {
    width: 50px;
    margin-right: 28px;
}

.code-box {
    display: flex;
    justify-content: space-between;
    width: 230px;
    margin: 80px auto;
    position: relative;
}

.code-box .code-item {
    width: 50px;
    height: 50px;
    background-color: #fff;
    border-radius: 5px 5px;
    text-align: center;
    line-height: 50px;
    font-size: 24px;
    color: #000;
    font-weight: bold;
    border: 1px solid rgb(209, 209, 209);
    transition: border 0.3s;
    box-sizing: border-box;
}

.code-box .code-input {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
}

.active {
    border: 3px solid #1E80FF !important;
}
</style>
<style lang="scss">
.modal-content .ivu-input {
    height: 50px !important;
    text-align: center;
}

.code-modal {
    .ivu-modal-header {
        display: none;
    }
}
</style>
